export default __webpack_public_path__ + "static/media/about_banner.6e9fb326.jpg";